import { z } from "zod";
import { Instant } from "./common.js";
import { Context } from "./identity.js";
import { Id } from "./ids.js";

/**
 * Notifications (architecture §9, DL-100…105). Quiet by default: only what needs a person gets through.
 * Three levels drive sound and escalation; coral is used only for `urgent` (design v2).
 */
export const NotificationLevel = z.enum(["normal", "important", "urgent"]);
export type NotificationLevel = z.infer<typeof NotificationLevel>;

/** What happened, so the client can choose an icon and a link. `module.what`. */
export const NotificationKind = z.string().regex(/^[a-z][a-z-]*\.[a-z][a-z-]*$/);

export const Notification = z.object({
  id: Id,
  createdAt: Instant,
  /** The context the recipient must be in to see it (ADR-29 §4: the customer context hides staff alerts). */
  context: Context,
  level: NotificationLevel,
  kind: NotificationKind,
  title: z.string().min(1).max(200),
  body: z.string().max(1000),
  entity: z.object({ type: z.string(), id: Id }).nullable(),
  readAt: Instant.nullable(),
});
export type Notification = z.infer<typeof Notification>;
